import React, {Component, PropTypes} from 'react'
import Elm from 'react-elm-components'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import config from '../../config'
import TicketCompanyInfosCardComponent from '../../../elm/src/TicketCompanyInfosCard.elm'

class TicketCompanyInfosCard extends Component {
    /*setupPorts = (ports) => {
        ports.dispatch.subscribe(this.subscribeDispatch)
    }*/
    /*
    subscribeDispatch = () => {
        const {dispatch} = this.props
        dispatch(push('/simplifiedrequests'))
    }*/

    render() {
        return (
            <div>
                <Elm src={TicketCompanyInfosCardComponent.Elm.TicketCompanyInfosCard}
                     ports={this.setupPorts}
                     flags={{apiUrl: config.api.url, company: this.props.company, agencies: this.props.agencies, patrimonyUid: this.props.patrimonyUid}}
                />
            </div>
        )
    }
}

export default connect()(TicketCompanyInfosCard)


// WEBPACK FOOTER //
// ./lib/ticket/components/TicketCompanyInfosCard.js